module.exports = __webpack_public_path__ + "static/requiredtags-5bb8748f5d9cd952252d29e62c1ce4ce.png";